import { unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-label"]

import { QuestionMarkCircleIcon } from '@heroicons/vue/20/solid'


export default {
  __name: 'HelpHint',
  props: { label: { type: String, required: true }, text: { type: String, required: true } },
  setup(__props) {



return (_ctx, _cache) => {
  const _directive_tippy = _resolveDirective("tippy")

  return _withDirectives((_openBlock(), _createElementBlock("button", {
    type: "button",
    "aria-label": __props.label,
    class: "inline-flex h-5 w-5 -translate-y-px items-center justify-center rounded-full align-middle text-gray-400 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-brand-500"
  }, [
    _createVNode(_unref(QuestionMarkCircleIcon), {
      class: "h-4 w-4",
      "aria-hidden": "true"
    })
  ], 8, _hoisted_1)), [
    [_directive_tippy, { content: __props.text, allowHTML: false, trigger: 'mouseenter focus click', placement: 'top', maxWidth: 300 }]
  ])
}
}

}